const SubjectsCalendar = () => import("./views/SubjectsCalendar.vue");
const FreeDays = () => import("./views/FreeDays.vue");
const BulkPresences = () => import("./views/BulkPresences.vue");
const UserCalendar = () => import("./views/UserCalendar.vue");

const route = "/calendar";

const routes = [
  {
    path: `${route}/user`,
    name: "calendar.user",
    component: UserCalendar,

    meta: {
      roles: ["ROLE_PARENT", "ROLE_INSTITUTION_WORKER"],
    },
  },

  {
    path: `${route}/subjects`,
    name: "calendar.subjects",
    component: SubjectsCalendar,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/freeDays`,
    name: "calendar.freeDays",
    component: FreeDays,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/bulkPresences`,
    name: "calendar.bulkPresences",
    component: BulkPresences,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];

export default routes;
